import React from "react";
import { JSX } from "react/jsx-runtime";

const CalendarIcon = (
  props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>
) => {
  return (
    <svg width="27" height="28" viewBox="0 0 27 28" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
        <path d="M7.13086 20.8431V20.7352M13.8809 20.8431V20.7352M13.8809 14.9941V14.8862M19.8809 14.9941V14.8862M2.63086 9.25288H23.6309M5.34515 1V3.15319M20.6309 1V3.15292M20.6309 3.15292H5.63086C3.14558 3.15292 1.13086 5.08072 1.13086 7.45877V21.8117C1.13086 24.1898 3.14558 26.1176 5.63086 26.1176H20.6309C23.1161 26.1176 25.1309 24.1898 25.1309 21.8117L25.1309 7.45877C25.1309 5.08072 23.1161 3.15292 20.6309 3.15292Z" stroke="#26397E" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  );
};

export default CalendarIcon;
